import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Select } from 'antd';
// Local Deps
import NFButton from '../../../../components/primitives/NFButton';
import msgs from '../../../../config/messages';

// import Loading from '../../components/Loading';
function FindOrganization({
  onChange,
  onSubmit,
  onCancel,
  organizationList,
  cage = ''
}) {
  return (
    <div>
      <Row style={{ flexWrap: 'nowrap' }}>
        <Col style={{ marginTop: '16px' }}>
          {/* <!-- LOADING --> */}
          {/* <!-- CONTENT --> */}
          <div className="nf-registration__content">
            <Row className="nf-row--justify-end" />
            {/* <!-- USERS GRID --> */}
            <div className="nf-registration__layout">
              <div className="nf-registration__input">
                <p>Find Your Organization</p>
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="Select an Organization"
                  optionFilterProp="children"
                  onChange={onChange}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {organizationList}
                </Select>
              </div>

              <div className="nf-registration--wrapper">
                <div className="nf-registration__buttons">
                  <NFButton
                    className="nf-button--gray-border"
                    style={{ marginRight: '16px' }}
                    onClick={() => {
                      onCancel();
                    }}
                  >
                    {msgs.Form.cancelButton}
                  </NFButton>
                  <NFButton
                    className="nf-button--form nf-button--orange"
                    type="submit"
                    disabled={!cage}
                    onClick={() => {
                      onSubmit();
                    }}
                  >
                    {msgs.Form.continueButton}
                  </NFButton>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

FindOrganization.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  organizationList: PropTypes.any.isRequired,
  cage: PropTypes.string,
};

FindOrganization.defaultProps = {
  cage: ''
};

export default FindOrganization;



// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/FindOrganization/FindOrganization.jsx